import isSideBoxItemElement from './isSideBoxItemElement';

export default isSideBoxItemElement;
